var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar-wrapper"},[_c('div',{staticClass:"top-bar",class:{ 'top-bar-fixed': _vm.fixed }},[_c('div',{staticClass:"nav-bar"},[_c('SearchBar'),_c('SortBySelector'),_c('CategoryFilter'),_c('RarityFilter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }